import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ImageUploadService {

  constructor(private http: HttpClient) { }

  uploadImage(imageUploadUrl: string, extension: any, file: any): Observable<Object> {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'image/' + extension
        })
    };
    return this.http.put(imageUploadUrl, file, httpOptions);
  }
}
